/**
 * UI-only configuration for the Knowledge Base widget.
 *
 * AWS infrastructure identifiers (KB IDs, model ARNs, agent runtime ARNs,
 * regions, account IDs) are NOT stored here — the backend controls them.
 */

export const KNOWLEDGE_BASE_CONFIG = {
  AVAILABLE_TOPICS: [
    'ALL_TOPICS',
    'Acute Wounds',
    'Affinity',
    'BoWC',
    'Chronic Wounds',
    'CYGNUS Dual',
    'Mohs Procedure',
    'NuShield',
    'NuShield Surgical',
    'PluraPly Antimicrobial',
  ],
};
